import React from 'react';
import { Skeleton, SkeletonBlock } from '@one-thd/sui-atomic-components';

const LinksSkeleton = () => {
  return (
    <div className="sui-flex sui-h-8 sui-overflow-hidden">
      <Skeleton
        grow
        disablePadding
        PaperProps={{
          className: 'sui-grow',
          variant: 'shadow'
        }}
      >
        <SkeletonBlock 
          aspect="wide"
        />
      </Skeleton>
    </div>
  );
};

export default LinksSkeleton;